import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import ReviewSummaryResult from '../../../widgets/reviewSummary/ReviewSummaryResult'
import { getSchemaReviewSummary } from '../../../redux/actions/reviewSummary'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'

export default function ReviewSummary() {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [schema, setSchema] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getSchemaReviewSummary(projectId)
      // console.log(JSON.stringify(_schema))
      setSchema(_schema.model)
      // setSchema(mockSchema.model)
    } catch (e) {
      setError({})
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal>
      <ContentHeader header={schema.header} subHeader={schema.subHeader} />

      <ReviewSummaryResult schema={schema.forms} isMulti={false} />
      <br />
    </SidebarProposal>
  )
}
